import React from "react";
import { Helmet } from 'react-helmet-async';

function AboutUs() {
  return (

    <div className="p-8 max-w-4xl mx-auto">
      <Helmet>
                <title>About us</title>
                <meta name="description" content="mushroom spores syringes" />
            </Helmet>
      <h1 className="text-3xl font-bold mb-4">About Spores Bro</h1>
      <p className="text-gray-700 mb-4">
        For over 2 decades Spores Bro has been helping noobs to master Bulk Psilocybe Cubensis growing at home.Our website has all the information a novice might need to go from noob to expert.
      </p>
      <p className="text-gray-700">
        Our Shop has the best Psilocybe Cubensis mushroom spores strain for the noob .
      </p>
      <p>Spores Bro: We grow together</p>
    </div>
  );
}

export default AboutUs;
